import { createAsyncThunk } from '@reduxjs/toolkit';

import { authGet } from '../../utils/request';

const getLogs = createAsyncThunk('logs/getLogs',
  async (_, { rejectWithValue, getState }) => {
    try {
      const {
        query, page, user, from, to,
        type: { value: typeValue } = {}, action: { value: actionValue } = {}, size
      } = getState().logsFilter;

      const { data } = await authGet(`/logs?page=${page}`,
        {
          params: {
            size,
            ...(typeValue && { type: typeValue }),
            ...(actionValue && { action: actionValue }),
            ...(user && { user }),
            ...(query && { query }),
            ...(from && { from: new Date(`${from}T00:00:00`).toISOString() }),
            ...(to && { to: new Date(`${to}T23:59:59.999`).toISOString() }),
          }
        });
      return data;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  });

export default getLogs;
